
import BranchDropdown from "@/components/BranchDropdown";
import { CashierChart } from "@/components/Charts/CashierChart";
import { CoastChart } from "@/components/Charts/CoastChart";
import { OnlineMenuChart } from "@/components/Charts/OnlineMenuChart";
import { PayoutsChart } from "@/components/Charts/PayoutsChart";
import { PercentegeChart } from "@/components/Charts/PercentegeChart";
import { TotalSalesChart } from "@/components/TotalSalesChart";
import { Calendar } from "@/components/ui/calendar";
import { ProductBranchSlice } from "@/store/BranchSlice";
import axios from "axios";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { DateRange } from "react-day-picker";
import { FaCalendarAlt, FaChartLine, FaChartPie, FaChevronDown, FaMoneyBillWave } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { IoCloseCircle } from "react-icons/io5";
import { MdAccountBalanceWallet } from "react-icons/md";
import { useSelector } from "react-redux";
import { ChartSkeleton } from "./ChartSkeleton";
import { useTranslation } from "react-i18next";
import FinancialReport from "@/components/FinancialReport";
import { RootState } from "@/store/store";
import { FinancialSummary } from "@/types/globalTypes";
import SalesCountChart from "@/components/Charts/SalesCountChart";
import { RiNumbersLine } from "react-icons/ri";
import toast from "react-hot-toast";
import { useUserRole } from "@/hooks/useUserRole";


type ReportCard = {
    key: string;
    icon: ReactNode;
    label: string;
    labelAr: string;
};
type coastData = {
    nameAR: string
    nameEN: string
    price: number | string
    productCost: number | string
}
type cashierAndMenuData = {
    key: string
    sales: number
}
type payoutsData = {
    key: string
    amount: number
}
type TotalSales = {
    key: string,
    sales: number,
    menuSales: number,
    cashierSales: number
}
type percentageData = {
    success: boolean
    sales: number
    onlineSales: number
    cashSales: number
    onlineRatio: number
    cashRatio: number
}
type salesCount = {
    _id: string;
    nameEN: string;
    nameAR: string;
    soldQuantity: number;
};


export default function Reports() {
    const {isOwner,openAppReviewBasedOnRole} = useUserRole()
    const [selectedTimeStart, setSelectedTimeStart] = useState<number | null>();
    const [selectedTimeEnd, setSelectedTimeEnd] = useState<number | null>();
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const baseUrl = import.meta.env.VITE_BASE_URL
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [selectedFilter, setSelectedFilter] = useState('')
    const [selectedBranch, setSelectedBranch] = useState<ProductBranchSlice[] | null>(null);
    const [chartDay, setChartDay] = useState<number | null>(null);
    const [lastMonthStart, setLastMonthStart] = useState<number | null>(null);
    const [lastMonthEnd, setLastMonthEnd] = useState<number | null>(null);
    const [currentMonthStart, setCurrentMonthStart] = useState<number | null>(null);
    const [currentMonthEnd, setCurrentMonthEnd] = useState<number | null>(null);
    const containerRef = useRef<HTMLDivElement>(null)
    const dateListRef = useRef<HTMLDivElement>(null)
    const dateContainerRef = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDateStart, setSelectedDateStart] = useState<string | null>(null)
    const [selectedDateEnd, setSelectedDateEnd] = useState<string | null>(null)
    const [dateOpen, setDateOpen] = useState(false);
    const [date, setDate] = useState<DateRange | undefined>({
        from: undefined,
        to: undefined,
    });
    const [hoveredDate, setHoveredDate] = useState<Date | undefined>();
    const displayRange = useMemo(() => {
        if (date?.from && !date.to && hoveredDate) {
            return {
                from: date.from,
                to: hoveredDate > date.from ? hoveredDate : date.from,
            };
        }
        return date;
    }, [date, hoveredDate]);
    const handleSelect = (selected: DateRange | undefined) => {
        if (!selected?.from) {
            // Reset everything if nothing selected
            setDate({ from: undefined, to: undefined });
            return;
        }

        if (selected.from && selected.to) {
            // Full range selected — commit it
            setDate(selected);
            return;
        }

        if (date?.from && !date.to) {
            // 'from' is already selected, now selecting 'to'
            if (selected.from.getTime() === date.from.getTime()) {
                // Clicked the same date twice → reset
                setDate({ from: undefined, to: undefined });
            } else {
                // Set full range
                setDate({
                    from: date.from,
                    to: selected.from,
                });
            }
        } else {
            // Start a new range
            setDate({ from: selected.from, to: undefined });
        }
    };
    console.log(selectedTimeEnd, selectedTimeStart, "selectedTimeEnd, selectedTimeStart");

    const [fromTime, setFromTime] = useState("");
    const [toTime, setToTime] = useState("");
    const [coastData, setCoastData] = useState<coastData[] | null>(null)
    const [cashierData, setCashierData] = useState<cashierAndMenuData[] | null>(null)
    const [menuData, setMenuData] = useState<cashierAndMenuData[] | null>(null)
    const [payoutsData, setPayoutsData] = useState<payoutsData[] | null>(null)
    const [totalSales, setTotalSales] = useState<TotalSales[] | null>(null)
    const [salesCountData, setSalesCountData] = useState<salesCount[] | null>(null)
    const [percentageData, setPercentageData] = useState<percentageData | null>(null)
    const [yesterday, setYesterday] = useState<number | null>();
    const [lastWeek, setLastWeek] = useState<number | null>(null)
    const [lastYear, setLastYear] = useState<number | null>(null)
    const [totalsData, setTotalsData] = useState<FinancialSummary | null>(null)
    const [currentYearStart, setCurrentYearStart] = useState<number | null>(null)
    const [currentYearEnd, setCurrentYearEnd] = useState<number | null>(null)
    const [filter, setFilter] = useState<string | null>("this month");
    const [fileLoading, setFileLoading] = useState(false);
    const userData = useSelector((state: RootState) => state.user.userData)
    const chartComponents: Record<string, JSX.Element | null> = {
        "": totalsData && percentageData ? <FinancialReport data={totalsData} percentageData={percentageData} /> : <ChartSkeleton />,
        "Cost": coastData ? <CoastChart data={coastData} /> : <ChartSkeleton />,
        "Pay Outs": payoutsData ? <PayoutsChart data={payoutsData} /> : <ChartSkeleton />,
        "menu_sales": menuData ? <OnlineMenuChart data={menuData} /> : <ChartSkeleton />,
        "cashier_sales": cashierData ? <CashierChart data={cashierData} /> : <ChartSkeleton />,
        "total_sales": totalSales ? <TotalSalesChart data={totalSales} /> : <ChartSkeleton />,
        "cash_online_ratio": percentageData ? <PercentegeChart data={percentageData} /> : <ChartSkeleton />,
        "sales-count": percentageData ? <SalesCountChart data={salesCountData} /> : <ChartSkeleton />,
    };

    function openDateList() {
        if (!dateOpen) {
            if (dateContainerRef.current) {
                dateContainerRef.current.classList.remove('hidden');
                dateContainerRef.current.classList.add('flex');
                setDateOpen(true);
            }
        }
    }
    function closeDateList() {
        if (dateOpen) {
            if (dateContainerRef.current) {
                dateContainerRef.current.classList.add('hidden');
                dateContainerRef.current.classList.remove('flex');
                setDateOpen(false);
            }
        }
    }

    const openDayList = () => {
        if (!isOpen) {
            if (dateListRef.current) {
                dateListRef.current.classList.remove('hidden');
                dateListRef.current.classList.add('flex');
                setIsOpen(true);
            }
        }
    };
    const reportCards: ReportCard[] = [
        {
            key: "",
            icon: <FaChartLine className="text-indigo-600 text-xl" />, // you can change icon if needed
            label: "Financial Report",
            labelAr: "التقرير المالي",
        },
        {
            key: "Cost",
            icon: <FaMoneyBillWave className="text-red-500 text-xl" />,
            label: "Costs",
            labelAr: "التكاليف",
        },
        {
            key: "Pay Outs",
            icon: <MdAccountBalanceWallet className="text-blue-500 text-xl" />,
            label: "Payouts",
            labelAr: "التحويلات",
        },
        {
            key: "total_sales",
            icon: <FaChartPie className="text-purple-600 text-xl" />,
            label: "Total Sales",
            labelAr: "إجمالي المبيعات",
        },
        {
            key: "sales-count",
            icon: <RiNumbersLine className="text-yellow-500 text-xl" />,
            label: "Number of Items Sold",
            labelAr: "عدد مبيعات العناصر",
        },

    ];

    const handleClickOutside = (event: MouseEvent) => {
        if (
            containerRef.current &&
            !containerRef.current.contains(event.target as Node)
        ) {
            if (dateListRef.current) {
                dateListRef.current.classList.add('hidden');
                dateListRef.current.classList.remove('flex');
                setIsOpen(false);
            }
        }
    };


    useEffect(() => {
    if(isOwner){
    openAppReviewBasedOnRole()
    } 
    // eslint-disable-next-line
    },[])

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const dateToUnix = (date: Date) => {
        return Math.floor(date.getTime() / 1000); // Convert Date to Unix timestamp (seconds)
    };

    function getTodayUnixTimestamp() {
        setChartDay(Math.floor(new Date().getTime() / 1000))

    }
    //^ gets yesterday timestamp
    function getYesterdayUnixTimestamp() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1); // Subtract 1 day
        setYesterday(Math.floor(yesterday.getTime() / 1000)); // Convert to UNIX timestamp (seconds)

    }
    function getLastWeekUnixTimestamp() {
        const lastWeek = new Date();
        lastWeek.setDate(lastWeek.getDate() - 7); // Subtract 7 days to get the same day last week
        setLastWeek(Math.floor(lastWeek.getTime() / 1000)) // Convert to UNIX timestamp (seconds)
    }
    function setLastMonthUnixRange() {
        const now = new Date();

        // Start of last month (e.g., June 1)
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);

        // End of last month (e.g., June 30 23:59:59)
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0); // 0 = last day of previous month
        lastMonthEnd.setHours(23, 59, 59, 999); // Set to end of day

        const startUnix = Math.floor(lastMonthStart.getTime() / 1000);
        const endUnix = Math.floor(lastMonthEnd.getTime() / 1000);

        setLastMonthStart(startUnix);
        setLastMonthEnd(endUnix);
    }

    function getLastYearUnixTimestamp() {
        const lastYear = new Date();
        lastYear.setFullYear(lastYear.getFullYear() - 1); // Subtract 1 year
        setLastYear(Math.floor(lastYear.getTime() / 1000)) // Convert to UNIX timestamp (seconds)
    }
    function getCurrentYearUnixTimestamps() {
        const startOfYear = new Date(new Date().getFullYear(), 0, 1); // January 1st of the current year
        const endOfYear = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59); // December 31st of the current year


        setCurrentYearStart(Math.floor(startOfYear.getTime() / 1000)); // Convert to Unix timestamp
        setCurrentYearEnd(Math.floor(endOfYear.getTime() / 1000)) // Convert to Unix timestamp

    }
    function getCurrentMonthUnixTimestamps() {
        const now = new Date(); // Current date
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // Start of the month
        const endOf29Days = new Date(startOfMonth); // Clone startOfMonth date
        endOf29Days.setDate(startOfMonth.getDate() + 28); // Add 28 days for a 29-day range


        setCurrentMonthStart(Math.floor(startOfMonth.getTime() / 1000)); // Convert to Unix timestamp
        setCurrentMonthEnd(Math.floor(endOf29Days.getTime() / 1000)) // Convert to Unix timestamp

    }

    const formatUnixTimestamp = (unixTimestamp: number | null): string => {
        if (unixTimestamp === null) {
            return "Invalid date"; // Return a default value
        }

        const date = new Date(unixTimestamp * 1000);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        if (!selectedDateEnd && !selectedDateStart) {
            setSelectedDateStart(formatUnixTimestamp(lastMonthStart))
            setSelectedDateEnd(formatUnixTimestamp(lastMonthEnd))
        }

        getTodayUnixTimestamp()
        getYesterdayUnixTimestamp()
        getLastWeekUnixTimestamp()
        setLastMonthUnixRange()
        getLastYearUnixTimestamp()
        getCurrentYearUnixTimestamps()
        getCurrentMonthUnixTimestamps()


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartDay])

    const formatDateWithTime = (
        unixTimestamp: number | null,
        time: string
    ): string => {
        if (unixTimestamp === null) {
            return "Invalid date";
        }

        const baseDate = formatUnixTimestamp(unixTimestamp); // your existing function
        return `${baseDate} ${time}`;
    };



    async function filterCharts({ start, end, branches }: { start: number, end: number, branches?: ProductBranchSlice[] }) {
        const coastApi = `${baseUrl}/api/dashboard/reports/costs`;
        const cashierApi = `${baseUrl}/api/dashboard/reports/cashier-sales`;
        const payoutApi = `${baseUrl}/api/dashboard/reports/payouts`;
        const menuApi = `${baseUrl}/api/dashboard/reports/menu-sales`;
        const totalSalesApi = `${baseUrl}/api/dashboard/reports/total-sales`;
        const percentageApi = `${baseUrl}/api/dashboard/reports/online-to-cash-sales`;
        const totalsApi = `${baseUrl}/api/dashboard/reports/totals`;
        const salesCountApi = `${baseUrl}/api/dashboard/reports/products-sales`;


        const startTime = fromTime
            ? formatDateWithTime(start, fromTime)
            : formatUnixTimestamp(start);

        const endTime = toTime
            ? formatDateWithTime(end, toTime)
            : formatUnixTimestamp(end);

        if (filter !== "custom") {
            setFromTime("");
            setToTime("");
        }

        try {
            if (selectedFilter === "") {
                const [totalsResponse, percentageResponse] = await Promise.all([
                    axios.get(totalsApi, {
                        params: {
                            startTime,
                            endTime,
                            branches:
                                (userData?.role === "owner" || userData?.role === "superadmin") && Array.isArray(branches)
                                    ? branches.map((branch) => branch._id)
                                    : undefined
                        },
                        headers: { Authorization: token }
                    }),
                    axios.get(percentageApi, {
                        params: {
                            startTime,
                            endTime,
                            branches: branches ? branches.map((branch) => branch._id) : undefined,
                        },
                        headers: { Authorization: token }
                    })
                ]);

                setTotalsData(totalsResponse.data);
                setPercentageData(percentageResponse.data);
            } else {
                const url =
                    selectedFilter === "cash_online_ratio" ? percentageApi :
                        selectedFilter === "cashier_sales" ? cashierApi :
                            selectedFilter === "Pay Outs" ? payoutApi :
                                selectedFilter === "menu_sales" ? menuApi :
                                    selectedFilter === "total_sales" ? totalSalesApi :
                                        selectedFilter === "sales-count" ? salesCountApi :
                                            coastApi;

                const response = await axios.get(url, {
                    params: {
                        startTime,
                        endTime,
                        branches: branches ? branches.map((branch) => branch._id) : undefined,
                    },
                    headers: { Authorization: token }
                });

                if (selectedFilter === "cash_online_ratio") {
                    setPercentageData(response.data);
                } else if (selectedFilter === "cashier_sales") {
                    setCashierData(response.data.analytics);
                } else if (selectedFilter === "Pay Outs") {
                    setPayoutsData(response.data.analytics);
                } else if (selectedFilter === "menu_sales") {
                    setMenuData(response.data.analytics);
                } else if (selectedFilter === "total_sales") {
                    setTotalSales(response.data.analytics);
                } else if (selectedFilter === "sales-count") {
                    setSalesCountData(response.data.analytics);
                } else {
                    setCoastData(response.data.analytics);
                }
            }

            setSelectedDateStart(formatUnixTimestamp(start));
            setSelectedDateEnd(formatUnixTimestamp(end));
        } catch (error) {
            console.error(error);
        } finally {
            if (filter !== "custom") {
                dateListRef.current?.classList.add('hidden');
                dateListRef.current?.classList.remove('flex');
                setIsOpen(false);
            } else if (date?.from && date?.to) {
                dateListRef.current?.classList.add('hidden');
                dateListRef.current?.classList.remove('flex');
                setIsOpen(false);
            }
        }
    }
    async function getXlsx({
        start,
        end,
        branches,
        type = "xlsx", // default to xlsx
    }: {
        start: number;
        end: number;
        branches?: ProductBranchSlice[];
        type?: "xlsx" | "pdf";
    }) {
        if (fileLoading) return;
        setFileLoading(true);

        const toastId = toast.loading(t("reports.LoadingReport"));

        const coastApi = `${baseUrl}/api/dashboard/reports/costs?locale=${lang}`;
        const cashierApi = `${baseUrl}/api/dashboard/reports/cashier-sales?locale=${lang}`;
        const payoutApi = `${baseUrl}/api/dashboard/reports/payouts?locale=${lang}`;
        const menuApi = `${baseUrl}/api/dashboard/reports/menu-sales?locale=${lang}`;
        const totalSalesApi = `${baseUrl}/api/dashboard/reports/total-sales?locale=${lang}`;
        const percentageApi = `${baseUrl}/api/dashboard/reports/online-to-cash-sales?locale=${lang}`;
        const totalsApi = `${baseUrl}/api/dashboard/reports/totals?locale=${lang}`;
        const salesCountApi = `${baseUrl}/api/dashboard/reports/products-sales?locale=${lang}`;

        const startTime = fromTime
            ? formatDateWithTime(start, fromTime)
            : formatUnixTimestamp(start);

        const endTime = toTime
            ? formatDateWithTime(end, toTime)
            : formatUnixTimestamp(end);

        if (filter !== "custom") {
            setFromTime("");
            setToTime("");
        }

        try {
            const getMimeType = (type: "xlsx" | "pdf") => {
                return type === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            };

            const getDefaultFileName = (type: "xlsx" | "pdf", filter?: string) => {
                const fallback = "report";
                const cleanFilter = filter?.replace(/\s+/g, "_").toLowerCase();
                return `InterFlow-Reports-${cleanFilter || fallback}.${type}`;
            };

            const params = {
                startTime,
                endTime,
                export: type,
                branches:
                    (userData?.role === "owner" || userData?.role === "superadmin") && Array.isArray(branches)
                        ? branches.map((branch) => branch._id)
                        : undefined,
            };

            const downloadBlob = (blobData: BlobPart, mimeType: string, filename: string) => {
                const blob = new Blob([blobData], { type: mimeType });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            };

            if (selectedFilter === "") {
                const totalsResponse = await axios.get(totalsApi, {
                    params,
                    headers: { Authorization: token },
                    responseType: "blob",
                });

                let filename = getDefaultFileName(type, "Financial Report");
                const disposition = totalsResponse.headers["content-disposition"];
                if (disposition) {
                    const match = disposition.match(/filename="?(.+)"?/);
                    if (match?.[1]) {
                        filename = match[1];
                    }
                }

                downloadBlob(totalsResponse.data, getMimeType(type), filename);
                toast.success(t("reports.reportDownloadedSuccessfully"));
            } else {
                const url =
                    selectedFilter === "cash_online_ratio"
                        ? percentageApi
                        : selectedFilter === "cashier_sales"
                            ? cashierApi
                            : selectedFilter === "Pay Outs"
                                ? payoutApi
                                : selectedFilter === "menu_sales"
                                    ? menuApi
                                    : selectedFilter === "total_sales"
                                        ? totalSalesApi
                                        : selectedFilter === "sales-count"
                                            ? salesCountApi
                                            : coastApi;

                const response = await axios.get(url, {
                    params,
                    headers: { Authorization: token },
                    responseType: "blob",
                });

                let filename = getDefaultFileName(type, selectedFilter);
                const disposition = response.headers["content-disposition"];
                if (disposition) {
                    const match = disposition.match(/filename="?(.+)"?/);
                    if (match?.[1]) {
                        filename = match[1];
                    }
                }

                downloadBlob(response.data, getMimeType(type), filename);
                toast.success(t("reports.reportDownloadedSuccessfully"));
            }

        } catch (error) {
            console.error(error);
        } finally {
            toast.dismiss(toastId);
            setFileLoading(false);
        }
    }



    useEffect(() => {
        if (!date?.from) return;

        const startUnix = dateToUnix(date.from);
        const endUnix = date.to ? dateToUnix(date.to) : startUnix; // If same-day, treat as single day

        setSelectedTimeStart(startUnix);
        setSelectedTimeEnd(endUnix);

        filterCharts({
            start: startUnix,
            end: endUnix,
            branches: selectedBranch ?? [],
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date, toTime]);


    function formatTo12Hour(time24: string): string {
        const [hourStr, minuteStr] = time24.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);

        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12;
        if (hour === 0) hour = 12;

        return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
    }


    useEffect(() => {

        if (selectedTimeEnd && selectedTimeStart) {
            filterCharts({ start: selectedTimeStart, end: selectedTimeEnd, branches: selectedBranch ?? [] });
        } else if (currentMonthStart && currentMonthEnd) {
            filterCharts({ start: currentMonthStart, end: currentMonthEnd, branches: selectedBranch ?? [] });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFilter, selectedTimeStart, selectedTimeEnd, currentMonthStart, currentMonthEnd]);
    return (<>
        {(userData?.role === "owner" || userData?.role === "superadmin") && (
            <BranchDropdown
                filterCharts={filterCharts}
                setFilter={setFilter}
                chartDay={chartDay}
                lastMonth={lastMonthStart}
                currentMonthStart={selectedTimeStart ? selectedTimeStart : currentMonthStart}
                currentMonthEnd={selectedTimeEnd ? selectedTimeEnd : currentMonthEnd}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
            />
        )}

        <div className="flex gap-5 flex-wrap">
            <div ref={containerRef} onClick={openDayList} className="relative w-fit bg-white ">
                <div onClick={(e) => {
                    e.preventDefault();
                    if (isOpen) {
                        if (!dateListRef.current) return;
                        dateListRef.current.classList.add('hidden');
                        dateListRef.current.classList.remove('flex');
                        setIsOpen(false);

                    }
                }} className="flex justify-center md:text-base text-sm whitespace-nowrap w-fit md:px-5 px-2 gap-1 py-2 items-center md:gap-5 border rounded-lg cursor-pointer">
                    <div className="flex items-center  gap-2">
                        <span ><FaCalendarAlt /></span>
                        <span className="text-primary font-semibold"> {t("reports.Reporthistory")}</span>
                    </div>
                    <span className="text-slate-400">{selectedDateStart} - {selectedDateEnd} {toTime && fromTime && `(${t("from")} ${formatTo12Hour(fromTime)} - ${t("to")} ${formatTo12Hour(toTime)}  )`}</span>
                    <FaChevronDown className="text-sm text-slate-400" />
                </div>
                <div ref={dateListRef} className={` w-fit  bg-gray-50 z-50 left-0 h-fit gap-5 flex-col lg:flex-row md:absolute hidden  ${lang === "en" ? "left-0" : "right-0"}`}>
                    <ul className={`text-gray-500  w-fit md:w-[200px] text-sm  h-fit rounded-lg border bg-white  `}>
                        <li onClick={() => {
                            closeDateList()
                            if (chartDay !== null && lastMonthStart !== null) {
                                filterCharts({ start: chartDay, end: chartDay, branches: selectedBranch || [] })
                                setSelectedTimeStart(chartDay)
                                setSelectedTimeEnd(chartDay)
                            }
                            setFilter("today")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "today" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.Today")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (yesterday !== null && yesterday !== undefined) {
                                filterCharts({ start: yesterday, end: yesterday, branches: selectedBranch || [] })
                                setSelectedTimeStart(yesterday)
                                setSelectedTimeEnd(yesterday)
                            }
                            setFilter("yesterday")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "yesterday" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.YesterDay")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (lastWeek !== null && lastWeek !== undefined && chartDay !== null) {
                                filterCharts({ start: lastWeek, end: chartDay, branches: selectedBranch || [] })
                                setSelectedTimeStart(lastWeek)
                                setSelectedTimeEnd(chartDay)
                            }
                            setFilter("last week")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "last week" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.LastWeek")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (lastMonthStart !== null && lastMonthStart !== undefined && lastMonthEnd !== null) {
                                filterCharts({ start: lastMonthStart, end: lastMonthEnd, branches: selectedBranch || [] })
                                setSelectedTimeStart(lastMonthStart)
                                setSelectedTimeEnd(lastMonthEnd)
                            }
                            setFilter("last month")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "last month" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.LastMonth")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (currentMonthEnd !== null && currentMonthStart !== null) {
                                filterCharts({ start: currentMonthStart, end: currentMonthEnd, branches: selectedBranch || [] })
                                setSelectedTimeStart(currentMonthStart)
                                setSelectedTimeEnd(currentMonthEnd)
                            }
                            setFilter("this month")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "this month" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.thisMonth")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (currentYearStart !== null && currentYearEnd !== null) {
                                filterCharts({ start: currentYearStart, end: currentYearEnd, branches: selectedBranch || [] })
                                setSelectedTimeStart(currentYearStart)
                                setSelectedTimeEnd(currentYearEnd)
                            }
                            setFilter("this year")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "this year" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.thisyear")}</li>
                        <li onClick={() => {
                            closeDateList()
                            if (lastYear !== null && lastYear !== undefined && chartDay !== null) {
                                filterCharts({ start: lastYear, end: chartDay, branches: selectedBranch || [] })
                                setSelectedTimeStart(lastYear)
                                setSelectedTimeEnd(chartDay)
                            }
                            setFilter("last year")
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "last year" && "font-semiblod bg-skyblue"} hover:bg-skyblue hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" />{t("reports.lastyear")}</li>
                        <li onClick={() => {
                            setFilter("custom")
                            openDateList()
                        }} className={`flex items-center gap-2 hover:text-black ${filter === "custom" && "font-semiblod bg-skyblue"} hover:bg-skyblue  hover:font-semiblod cursor-pointer px-5  py-2 transition-all duration-200`}> <GoDotFill className="text-[15px]" /> {t("reports.ChooseAperiod")}</li>
                    </ul>
                    <div ref={dateContainerRef} className="z-50 border rounded-md hidden  flex-col">
                        <Calendar
                            mode="range"
                            selected={displayRange}
                            onSelect={handleSelect}
                            onDayMouseEnter={(date) => setHoveredDate(date)}
                            onDayMouseLeave={() => setHoveredDate(undefined)}
                            numberOfMonths={2}
                            disabled={{ after: new Date() }}
                            initialFocus
                            toYear={new Date().getFullYear()}
                            dir={lang === "ar" ? "rtl" : "ltr"}
                            className=" p-3 ms-5  bg-white dark:bg-white text-black"
                            classNames={{
                                day_range_start:
                                    "bg-sidebar rounded-none text-skyblue hover:text-white hover:bg-sidebar",
                                day_range_end:
                                    "bg-sidebar rounded-none text-skyblue hover:text-white hover:bg-sidebar",
                                day_range_middle:
                                    "bg-skyblue rounded-none dark:bg-skyblue text-black hover:text-slate-900 hover:bg-skyblue",
                                day_selected:
                                    "bg-black rounded-none text-black hover:bg-black hover:text-white",
                                day_today:
                                    "border rounded-none border-sidebar text-black hover:text-slate-900 hover:bg-skyblue",
                                nav_button_next: "bg-white dark:bg-white border-0",
                                nav_button_previous: "bg-white dark:bg-white rotate-180 border-0",
                            }}
                        />

                        <div className="flex gap-4 items-center justify-center bg-white py-2">
                            <div>
                                <label className="block text-sm mb-1 text-center">{t("from")}</label>
                                <input
                                    type="time"
                                    value={fromTime}
                                    onChange={(e) => setFromTime(e.target.value)}
                                    className="border rounded px-2 py-1"
                                />
                            </div>
                            <div>
                                <label className="block text-sm mb-1 text-center">{t("to")}</label>
                                <input
                                    type="time"
                                    value={toTime}
                                    onChange={(e) => setToTime(e.target.value)}
                                    className="border rounded px-2 py-1"
                                />
                            </div>
                        </div>




                    </div>

                </div>
            </div>
            <div className="flex items-center gap-3 whitespace-nowrap text-sm">
                <button
                    className="flex items-center gap-2 bg-skyblue text-sidebar  hover:text-skyblue hover:bg-sidebar transition-colors duration-200 font-semibold px-4 py-2 rounded-lg  w-fit"
                    onClick={() => {
                        if (selectedTimeStart && selectedTimeEnd) {
                            getXlsx({
                                type: "xlsx",
                                start: selectedTimeStart,
                                end: selectedTimeEnd,
                                branches: selectedBranch ?? [],
                            });
                        } else {
                            getXlsx({
                                type: "xlsx",
                                start: currentMonthStart ? currentMonthStart : 0,
                                end: currentMonthEnd ? currentMonthEnd : 0,
                                branches: selectedBranch ?? [],
                            });
                        }
                    }}
                >

                    {t("reports.downloadXls")}
                </button>
                <button
                    className="flex items-center gap-2 bg-skyblue text-sidebar hover:text-skyblue hover:bg-sidebar transition-colors duration-200 font-semibold px-4 py-2 rounded-lg  w-fit"
                    onClick={() => {
                        getXlsx({
                            type: "pdf",
                            start: selectedTimeStart ?? currentMonthStart ?? 0,
                            end: selectedTimeEnd ?? currentMonthEnd ?? 0,
                            branches: selectedBranch ?? [],
                        });
                    }}
                >

                    {t("reports.downloadPdf")}
                </button>
            </div>


        </div>

        <div className="relative w-full mt-5">
            <div
                className="flex overflow-x-auto gap-3 px-1 pb-2 "
            >
                {reportCards.map((card) => {
                    const isSelected = selectedFilter === card.key;

                    return (
                        <div
                            key={card.key}
                            onClick={() => {
                                setSelectedFilter(card.key)
                            }}
                            className={`
            min-w-[140px] max-w-[160px] snap-start
            border px-3 py-3 rounded-xl cursor-pointer flex-shrink-0
            flex flex-col justify-between transition-all duration-200
            shadow-sm hover:shadow-md hover:scale-[1.02]
            ${isSelected ? "bg-primary text-white" : "bg-white text-gray-800 hover:bg-gray-50"}
          `}
                        >
                            <div className="flex justify-between items-start">
                                {card.icon}
                                {isSelected && card.key !== "" && (
                                    <IoCloseCircle
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedFilter("");
                                        }}
                                        className="text-red-500 text-lg hover:scale-110 transition-transform"
                                    />
                                )}
                            </div>

                            <div className="mt-3 flex flex-col items-start gap-1">
                                <h3 className={`truncate text-[11px] font-medium ${isSelected ? "text-white" : "text-gray-700"}`}>
                                    {lang === "ar" ? card.labelAr : card.label}
                                </h3>
                            </div>
                        </div>
                    );
                })}
            </div>


        </div>



        <div className="mt-6">
            {chartComponents[selectedFilter]}
        </div>
    </>
    )
}
